(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('saasIcon', ["path", function (path) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('saas-icon').template(),
            scope: { saas: '=' },
            link: function ($scope) {
                $scope.paths = _.range(20);
            }
        };
    }]);
}());